<template>
  <div>
    <div :class="'biographiesContainer'+(this.data.isFullScreen?' fullscreened':'')" ref="biographiesContainer">
      <div class="headerText">Speaker Profiles</div>
      <div
        class="singleBiographyContainer"
        v-for="(bio, index) in data.biographies"
        :key="index"
        ref="singleBiographyContainer"
      >
        <div :class="'contentHeader'+(bio.expandBio?' active':'')" @click="expandBio(index)">
          <img class="image" :src="('.'+bio.image)" />
          <div class="textContainer">
            <div class="name">{{ bio.name }}</div>
            <div class="designation">{{ bio.designation }}</div>
          </div>
          <div class="arrowContainer" v-if="!data.isFullScreen">
              <fa-icon
              :icon="['fas', 'chevron-down']"
              v-if="!bio.expandBio"
            ></fa-icon>
              <fa-icon
              :icon="['fas', 'chevron-up']"
              v-if="bio.expandBio"
            ></fa-icon>
          </div>
          <slot name="crossButton"></slot>
        </div>
        <div
          :class="bio.expandBio || data.isFullScreen ? 'mainContent expanded' : 'mainContent'"
          :style="(data.isFullScreen ? 'height:'+(isMoreOpen?'auto':containerheight+'px'):'')"
        >
        <div class="categoryContainer">
          <div class="categoryHeader">About</div>
          <div class="categoryBody">{{ bio.about }}</div>
        </div>
        <div class="categoryContainer">
          <div class="categoryHeader">Publications</div>
          <div class="categoryBody">
            <a v-for="(title,ind) in bio.publications.title" :href="bio.publications.url[ind]" :key="ind">{{title}}</a>
          </div>
          <div v-if="data.isFullScreen && isMoreNeeded" class="moreButton" @click="showMoreClicked">{{(isMoreOpen?'Show Less':'Show More')}}</div>
        </div>
        <div class="categoryContainer">
          <div class="categoryHeader">Disclosure</div>
          <div class="categoryBody">{{ bio.disclosure }}</div>
        </div>
        </div>
    <slot name="backToTopButton"></slot>
      </div>
    </div>
  </div>
</template>

<script>
import "../scss/biographies-content.css";
import {LoadPulicationDataFromGoogleSheet} from "../general-functions"
export default {
  methods: {
    runFirstLoad() {
      this.data.biographies.forEach(async element => {
        element.publications=await LoadPulicationDataFromGoogleSheet(element.publicationsURL);
        this.$nextTick(() => {
          this.resize()
          this.$parent.resize();
        });
      });
    },
    expandBio(index) {
      if(this.data.isFullScreen)
        return
      this.data.biographies[index].expandBio = !this.data.biographies[index].expandBio;
      this.$nextTick(() => {
        this.$parent.resize();
      });
    },
    showMoreClicked(){
      this.isMoreOpen=!this.isMoreOpen
      this.$nextTick(() => {
        this.$parent.resize();
      });
    },
    speakerEvent(e){
      if(e.detail.state=="clicked"){
        if(this.$parent.saveScrollState!=null)
          this.scrollSaveCount = this.$parent.saveScrollState(this);
        var biographyIndex = this.data.biographies.findIndex(x=>x.name==e.detail.data.name)
        let biography=this.$refs.biographiesContainer.children[biographyIndex]
        if(biography!=null&&!biography.classList.contains("focusBlink")){
          biography.classList+=" focusBlink"
        }
        setTimeout(() => {
          if(biography!=null)
            biography.classList.remove("focusBlink")
        }, 4000);
        if(this.initialPrefs.showDesktopOverlays){
          let customEvent = new CustomEvent("openDesktopOverlay", {
            detail: {
              component: "biographiesContent",
              data: {
                biographies: [this.data.biographies[biographyIndex]],
                isFullScreen: true,
                curBiography:biographyIndex
              },
            },
          });
          this.$root.$emit('pauseVideo')
          window.dispatchEvent(customEvent);
        }
      }
      // else if(e.detail.state=="hidden"){
      //   this.$parent.cancelAutoScrollState(this.scrollSaveCount);
      // }
    },
    resize(){
      let maxHeight=0;
      let publicationHeight=0;
      let subItems=this.$refs.singleBiographyContainer[0].children[1].children
      for(let i=0;i<subItems.length;i++){
        let curHeight= 0;
        if(i==1){
          for(let j=1;j<subItems[i].children.length;j++){
            publicationHeight+=subItems[i].children[j].getBoundingClientRect().height
          }
          continue
        }
        for(let j=0;j<subItems[i].children.length;j++){
          curHeight+=subItems[i].children[j].getBoundingClientRect().height
        }
        if(curHeight>maxHeight){
          maxHeight=curHeight
        }
      }
      this.containerheight=maxHeight + 30
      if(publicationHeight>this.containerheight){
        this.isMoreNeeded = true
      }
    },
  },
  created(){
    for(var i=0;i<this.data.biographies.length;i++){
      this.data.biographies[i].publications={
        title:[]
      }
    }
    if(this.data.isFullScreen){
      this.runFirstLoad()
    }
    window.addEventListener("speakerButtonEvent",this.speakerEvent)
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  watch:{
    'data.publications':function(){
      this.$parent.resize();
    }
  },
  mounted(){
    if(this.data.isFullScreen){
      this.resize()
    }
  },
  data() {
    return {
      isMoreOpen: false,
      containerheight: 0,
      isMoreNeeded:false
    };
  },
};
</script>
